export const fiatBrands = [
  'mastercard',
  'muchbetter',
  'flexepin',
  'Ecopayz',
  'Maestro',
  'Neteller',
  'Instadebit',
  'visa',
  'jeton',
  'astropay',
  'neosurf',
  'iDebit',
  'Vernus',
  'Transfer',
  'mastercard',
  'maestro',
  'interac online',
  'piastrix',
];

export const brandSizeMap = {
  interac: { width: 116, height: 55 },
  skrill: { width: 82, height: 40 },
  mifinity: { width: 140, height: 40 },
  usdt: { width: 92, height: 40 },
  crypto: { width: 116, height: 40 },
  creditcard: { width: 116, height: 50 },
  fiat: { width: 116, height: 40 },
};

export const getBrandKey = (brand: string): keyof typeof brandSizeMap => {
  const lower = brand.toLowerCase();
  if (fiatBrands.some((f) => lower.includes(f))) return 'fiat';
  if (lower.includes('interac')) return 'interac';
  if (lower.includes('mifinity')) return 'interac';
  if (lower.includes('usdt')) return 'usdt';
  if (lower.includes('skrill')) return 'skrill';
  if (lower.includes('coinspaid')) return 'crypto';
  if (lower.includes('creditcard')) return 'creditcard';
  return 'fiat';
};
